import type { FunctionComponent } from 'react';

import { Link } from '@dr.pogodin/react-utils';

import { P_WEBSITE_CONTACT, getConfig } from 'utils';

import bgSupportUrl from 'assets/images/bg-support.png';
import IconChevron from 'assets/images/icon-chevron-20px.svg';

import Icon from 'assets/images/icon-lifebuoy-20px.svg';

import './style.scss';

const SupportAndResources: FunctionComponent = () => {
  const config = getConfig(true);
  return (
    <div styleName="container">
      <div styleName="header">
        <div styleName="icon">
          <Icon />
        </div>
        Support & Resources
      </div>
      <div styleName="card">
        <img alt="" src={bgSupportUrl} styleName="cardImage" />
        <div styleName="cardTitle">We&apos;re here for you</div>
        <p styleName="cardText">
          Get help, find answers, and keep creating with confidence
        </p>
        <Link
          styleName="button"
          to={`${config.HTTP_SCHEMA}${config.DOMAIN}${P_WEBSITE_CONTACT}`}
        >
          Contact Support <IconChevron styleName="buttonIcon" />
        </Link>
      </div>
    </div>
  );
};

export default SupportAndResources;
